module.exports = __webpack_public_path__ + "img/newspic3.bbf4ff14.jpg";